import { QUERY_KEYS } from "@app/dashboard/constants/query-keys";
import { getNetSales } from "@app/dashboard/services/inner_layout/home/charts";
import type { IHomeApisParams } from "@app/dashboard/types/innerLayout/home";
import Line from "../lineChart";

const NetSales = (
  { apiParams, timeFormat, rangeType }
    :
    { apiParams: IHomeApisParams, timeFormat: string, rangeType: string }

) => {
  return (
    <Line
      rangeType={rangeType}
      apiParams={apiParams}
      timeFormat={timeFormat}
      queryKey={QUERY_KEYS.GET_NET_SALES}
      queryFn={getNetSales}
    />
  )
}

export default NetSales;